// const baseUrl = "https://masterclass-276810.uc.r.appspot.com/api";
// const baseUrl = "http://localhost:4000/api";
const baseUrl = "https://masterclassofbeauty.com/api";

export const domain = "https://masterclassofbeauty.com";
export const secretKey = "K2MQ448OJA6UW1OD9V14"
export const stripePayoutClientId = 'ca_HQtvIOtIPcCGOXezuPrXUl9jqpGgbffB'
export const stripeSecretKey = "pk_live_ycN55ClfU1nsYAyTsi84Vq8400LMV9AgGU"
export default baseUrl;